import chevronLeft from '@iconify/icons-ant-design/left-outline';
import React from 'react';
import { IconButton } from 'rsuite';
import { IconGeneric } from '@/widgets/components/icon';
import styled from 'styled-components';

console.info('login form header file');

const Wrapper = styled.div`
  display: flex;
  width: 400px;
  align-items: flex-start;
  margin-left: 20px;
  margin-right: 20px;
`;

const StyledIconButton = styled(IconButton)`
  padding: 0 5px !important;
  margin-left: 20px;
  display: flex;
  align-items: center;
`;

const StyledIconLabel = styled.span`
  font-size: 14px;
`;

export function LoginFormHeader({ goBack }) {
  return (
    <Wrapper>
      <StyledIconButton
        css="padding-left: 0;" // eliminates rsuite component padding
        size="xs"
        appearance="subtle"
        icon={<IconGeneric icon={chevronLeft} />}
        onClick={goBack}
      >
        <StyledIconLabel>&nbsp;Back</StyledIconLabel>
      </StyledIconButton>
    </Wrapper>
  );
}
